import {Component, effect, input, signal, WritableSignal} from '@angular/core'
import {BaseTable} from '@sparbanken-syd/sparbanken-syd-theme'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table'
import {DecimalPipe} from '@angular/common'

interface IRow {
  id: string
  name: string
  listInterest: WritableSignal<number>
}

@Component({
  selector: 'spb-savings-interests',
  imports: [
    MatCell,
    MatCellDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    DecimalPipe
  ],
  templateUrl: './savings-interests.html',
  // Borrow some styles..
  styleUrls: ['../../tables.scss', '../production-price-table/production-price-table.scss']

})
export class SavingsInterests extends BaseTable<IRow> {

  public interests = input.required<[string, number][]>()

  public accounts = [
    {id: 'i15', name: 'Private banking', listInterest: signal(0)},
    {id: 'i16', name: 'Specialinlåning', listInterest: signal(0)},
    {id: 'i24', name: 'Fasträntekonto', listInterest: signal(0)},
    {id: 'i25', name: '6 mån', listInterest: signal(0)},
    {id: 'i26', name: '1 år', listInterest: signal(0)},
    {id: 'i27', name: '1,5 år', listInterest: signal(0)},
    {id: 'i28', name: '2 år', listInterest: signal(0)},
    {id: 'i29', name: '3 år', listInterest: signal(0)},
    {id: 'i30', name: '4 år', listInterest: signal(0)},
    {id: 'i31', name: '5 år', listInterest: signal(0)},
    {id: 'i32', name: 'Fasträntekonto 3-mån auto', listInterest: signal(0)},
    {id: 'i51', name: 'Österlenkonto', listInterest: signal(0)},
    {id: 'i83', name: 'e-sparkonto', listInterest: signal(0)},
    {id: 'i84', name: 'Hästsparkonto', listInterest: signal(0)}
  ]

  private readonly accountMap = new Map<string, WritableSignal<number>>(
    this.accounts.map(r => [r.id, r.listInterest])
  )

  constructor() {
    super()
    this.columns.set(['id', 'name', 'listInterest'])
    effect(() => {
      this.interests().forEach(([k, v]) => {
        const s = this.accountMap.get(k)
        s?.set(v)
      })
    })
    this.items.data = this.accounts
  }
}
